export default __webpack_public_path__ + "static/media/tete73.e1feb6c2.png";